module.exports = __webpack_public_path__ + "img/operator.907fca05.png";